import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import './LifeStyleBanner.scss';

/**
 * @group Layout
 * Displays Life style banner component
 */

const LifeStyleBanner = (props) => {
  const { opts = {} } = props;
  const {
    id,
    ctaLink,
    heading,
    subHeading,
    backgroundImage = {}
  } = opts;

  return (
    <div
      id="EtchLifeStyleBanner"
      data-module-id={id}
    >
      <a href={ctaLink}>
        <div className="imageBanner">
          <Image alt={backgroundImage.alt} src={backgroundImage.src} />
        </div>
        <div>
          <h2>{heading}</h2>
          <h4>{subHeading}</h4>
        </div>
      </a>
    </div>
  );
};

LifeStyleBanner.propTypes = {
  opts: PropTypes.shape({
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    ctaLink: PropTypes.string,
    backgroundImage: PropTypes.shape({
      src: PropTypes.string
    })
  }).isRequired
};

export default LifeStyleBanner;
